
import { createApiClient } from 'Network/ApiClient';

export const IcdAllowedIcdAxiosInstance = createApiClient('diagnoses/');


